import Swiper from 'swiper';
import {Navigation, A11y, Keyboard, Pagination} from 'swiper/modules';


const swiperTestimonials = document.querySelectorAll('.block-testimonials .swiper');

if (swiperTestimonials.length > 0) {
    swiperTestimonials.forEach(testimonialSlider=>{

        let direction = 'next';
        const logo = testimonialSlider.querySelector('.logo-element');

        new Swiper(testimonialSlider, {
            modules: [Navigation, A11y, Keyboard, Pagination],
            speed: 320,
            slidesPerView: 1,

            keyboard: {
                enabled: true,
            },

            navigation: {
                nextEl: '.custom-swiper-button-next',
                prevEl: '.custom-swiper-button-prev',
            },

            on: {
                slideChange: function() {

                    direction = this.realIndex > this.previousIndex ? 'next' : 'prev';

                    logo.classList.add(direction === 'next' ? 'is-rotating-forward' : 'is-rotating-backward');
                    logo.addEventListener('animationend', () => {
                        logo.classList.remove('is-rotating-forward', 'is-rotating-backward');
                    }, { once: true });
                },

                changeDirection: function() {

                }
            }

            // pagination: {
            //     // el: ".testimonials-pagination",
            //     el: ".swiper-pagination-custom",
            //     clickable: true,
            //     /*Return bullets as numbers*/
            //     renderBullet: function (index, className) {
            //         return '<button class="' + className + '">' + (index + 1) + "</button>";
            //     }
            // }
        });
    })
}





